import _ from "underscore";
import { FILTER_TYPE_MULTISELECT, FILTER_TYPE_YESNO } from "@/store/system/helpers";
import store from "@/store";
import {
  getSharedSearchFilters as getProviderSearchFilters,
  getSharedBlankCriteria as getProviderBlankCriteria
} from "@/store/providers/helpers";

export function getBlankCriteria() {
  return { ...getSharedBlankCriteria(), ...getProviderBlankCriteria() };
}

export function getSharedBlankCriteria() {
  return {
    administrationFeeExempt: null,
    financialStatementSupplied: null,
    hasLatePaymentMeasure: null,
    hasNotesForLevyCollection: null,
    heApplicationStatus: [],
    isFavourite: null,
    isLiableForLastYearsAdministrativeFee: null,
    isNew: null,
    levyCapApplies: null,
    levyCollectionProviderStatus: [],
    levyCollectionProviderWarningTypes: [],
    loanType: [],
    overrideCategories: [],
    paymentStatus: [],
    riskRatingExempt: null,
    sanctioned: null,
    shortRegistrationPeriod: null,
    specialTuitionProtectionExempt: null
  };
}

export function getSearchFilters() {
  return _(getSharedSearchFilters()).union(getProviderSearchFilters());
}

export function getSharedSearchFilters(prefix = "") {
  return [
    {
      text: prefix + "Status",
      value: "levyCollectionProviderStatus",
      type: FILTER_TYPE_MULTISELECT,
      default: true,
      items: store.state.lookups.data.levyCollectionProviderStatuses
    },
    { text: prefix + "Favourite", value: "isFavourite", type: FILTER_TYPE_YESNO },
    {
      text: prefix + "Payment status",
      value: "paymentStatus",
      type: FILTER_TYPE_MULTISELECT,
      items: store.state.lookups.data.paymentStatuses
    },
    {
      text: prefix + "Warning or flag",
      value: "levyCollectionProviderWarningTypes",
      type: FILTER_TYPE_MULTISELECT,
      items: store.state.lookups.data.levyCollectionProviderWarningTypes
    },
    {
      text: prefix + "Overrides",
      value: "overrideCategories",
      type: FILTER_TYPE_MULTISELECT,
      items: store.state.lookups.data.overrideCategories,
      exclude: ["RemoveProvider"]
    },
    { text: prefix + "New for levy collection", value: "isNew", type: FILTER_TYPE_YESNO },
    {
      text: prefix + "Liable for last year's admin fee",
      value: "isLiableForLastYearsAdministrativeFee",
      type: FILTER_TYPE_YESNO
    },
    { text: prefix + "Administrative fee exempt", value: "administrationFeeExempt", type: FILTER_TYPE_YESNO },
    { text: prefix + "Risk rating exempt", value: "riskRatingExempt", type: FILTER_TYPE_YESNO },
    {
      text: prefix + "Special tuition protection exempt",
      value: "specialTuitionProtectionExempt",
      type: FILTER_TYPE_YESNO
    },
    { text: prefix + "Levy cap applies", value: "levyCapApplies", type: FILTER_TYPE_YESNO },
    {
      text: prefix + "Financial statement supplied",
      value: "financialStatementSupplied",
      type: FILTER_TYPE_YESNO
    },
    { text: prefix + "Has late payment measure", value: "hasLatePaymentMeasure", type: FILTER_TYPE_YESNO },
    { text: prefix + "Sanctioned", value: "sanctioned", type: FILTER_TYPE_YESNO },
    { text: prefix + "Short registration period", value: "shortRegistrationPeriod", type: FILTER_TYPE_YESNO },
    { text: prefix + "Has notes for levy collection", value: "hasNotesForLevyCollection", type: FILTER_TYPE_YESNO }
  ];
}

export function getBlankRecord() {
  return {
    id: null,
    providerId: null,
    providerName: null,
    providerTradingNames: null,
    providerCode: null,
    status: null,
    favourite: null,
    hasValidContacts: null,
    invoiceGenerated: null,
    overrides: [],
    levyParameters: {
      administrationFeeExempt: null,
      totalAssets: null,
      failedEftsl: null,
      financialStatementSupplied: null,
      hasBeenSanctioned: null,
      shortRegistrationPeriod: null,
      isLiableForLastYearsAdministrativeFee: null,
      isNew: null,
      latePaymentMeasure: null,
      loanAmountsPaid: null,
      missingEftsl: null,
      netProfitBeforeTax: null,
      ongoingEftsl: null,
      passedEftsl: null,
      riskRatingExempt: null,
      specialTuitionProtectionExempt: null,
      studentCount: null,
      substitutedParameters: null,
      totalEquity: null,
      totalLiabilities: null,
      totalRevenue: null,
      withdrawnEftsl: null
    },
    levyCalculation: {
      administrativeFee1: null,
      administrativeFee2: null,
      administrativeFeeComponent: null,
      completionRate: null,
      courseCompletionScore: null,
      debtToEquity: null,
      debtToEquityScore: null,
      financialStrengthScore: null,
      lastYearsAdministrativeFee: null,
      latePaymentMeasure: null,
      netProfitRatio: null,
      netProfitRatioScore: null,
      nonComplianceScore: null,
      returnOnAssets: null,
      returnOnAssetsScore: null,
      riskPremium1: null,
      riskPremium2: null,
      riskPremiumBase: null,
      riskRatedPremiumComponent: null,
      specialTuitionProtectionComponent: null,
      totalLevy: null
    },
    estimatorKey: null,
    paymentStatus: null,
    latePaymentDays: null,
    incompleteContacts: null,
    incompleteContactsExplanation: null,
    incompleteLevyParameters: null,
    incompleteLevyParametersExplanation: null,
    paused: null,
    pausedExplanation: null,
    manuallyFinalised: null,
    manuallyFinalisedReason: null,
    manuallyFinalisedExplanation: null,
    sapReconciliationWarning: null,
    warnings: [],
    noteCount: null,
    levyCollectionId: null,
    levyCollectionDescription: null,
    links: []
  };
}
